import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f78a4dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "functionality" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer spacer__large" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Jumbortron = _resolveComponent("Jumbortron")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_List = _resolveComponent("List")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Jumbortron, {
      title: _ctx.data?.Hero?.Title,
      full: true,
      background: 
        _ctx.data ? _ctx.backendUrl + _ctx.data?.Hero?.Background.data.attributes.url : ''
      ,
      scrollTo: {
        id: 'next',
        img: _ctx.data ? _ctx.backendUrl + _ctx.data?.Hero?.Arrow.data.attributes.url : '',
      }
    }, null, 8, ["title", "background", "scrollTo"]),
    _createVNode(_component_Paragraph, {
      id: "next",
      block: 
        _ctx.data?.Blocks?.find((block) => block.__component === 'blocks.paragraph')
      
    }, null, 8, ["block"]),
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.Blocks.filter(
        (block) => block.__component === 'blocks.list'
      ), (block, index) => {
      return (_openBlock(), _createBlock(_component_List, {
        fit: index === 1,
        key: block.id,
        block: block
      }, null, 8, ["fit", "block"]))
    }), 128)),
    _hoisted_3,
    _createVNode(_component_Contact)
  ]))
}